import { Box, Dialog, DialogContent, FormControl, InputLabel, MenuItem, Select, Tab, Tabs, TextField, Typography, InputAdornment } from "@mui/material";
import React, { useEffect, useState } from "react";
import { region } from "../../config/images";
import SearchIcon from "@mui/icons-material/Search";
import RegionTable from "./RegionTable";
import StateTable from "./StateTable";
import LocalGovernment from "./LocalGovernment";
import { addLocalGovernmentList, addRegionList, addStateList, getLocalGovernmentList, getRegionList, getRegionLocalityDemoFile, getStateDetails, getStateList, importLocalGovernmentExcel, importRegionExcel, importStateExcel, localgovBulkDelete, regionBulkDelete, stateBulkDelete } from "../../config/services";
import translations from "../../config/language";
import { downloadFile } from "../../config/DownloadFile";
import { notifyError, notifySuccess } from "../../config/ToastMessage";
import { useSelector } from "react-redux";

const Region = () => {
  const [activeTab, setActiveTab] = useState(0);
  const [regionpopup, setRegionPopup] = useState(false);
  const [statePopup, setStatePopup] = useState(false);
  const [localGovernmentPopup, setLocalGovernmentPopup] = useState(false);
  const [importExcel, setImportExcel] = useState(false);
  const [selectedFile, setSelectedFile] = useState(null);
  const [regionName, setRegionName] = useState();
  const [searchText, setSearchText] = useState();
  const [debounceSearchText, setDebouncedSearchText] = useState();
  const [regionData, setRegionData] = useState([]);
  const [stateData, setStateData] = useState([]);
  const [localGovernmentData, setLocalGovernmentData] = useState([]);
  const [regionCurrentPage, setRegionCurrentPage] = useState(1);
  const [regionCount, setRegionCount] = useState();

  const [stateCurrentPage, setStateCurrentPage] = useState(1);
  const [stateCount, setStateCount] = useState();

  const [localGovCurrentPage, setLocalGovCurrentPage] = useState(1);
  const [localGovCount, setLocalGovCount] = useState();
  const [perPage, setPerPage] = useState(10);

  const [selectedRegion, setSelectedRegion] = useState(""); // Store selected region for state
  const [selectedState, setSelectedState] = useState(""); // Store selected state for local government
  const [state, setState] = useState();
  const [category, setCategory] = useState();

  // 🔹 Flags to determine which data should be refreshed
  const [regionUpdated, setRegionUpdated] = useState(false);
  const [stateUpdated, setStateUpdated] = useState(false);
  const [localGovUpdated, setLocalGovUpdated] = useState(false);

  // 🔹 Loading
  const [regionLoading, setRegionLoading] = useState(false);
  const [stateLoading, setStateLoading] = useState(false);
  const [localGovLoading, setLocalGovLoading] = useState(false);
  const [stateBasedOnRegion, setStateBasedOnRegion] = useState([]);

  // 🔹 Bulk Delete
  const [bulkDeleteLoading, setBulkDeleteLoading] = useState(false);
  const [selectedRegionsTable, setSelectedRegionsTable] = useState([]);
  const [selectedStateTable, setSelectedStateTable] = useState([]);
  const [selectedlocalgovTable, setSelectedLocalgovTable] = useState([]);
  const [importExcelLoading, setImportExcelLoading] = useState(false);

  const { module_access } = useSelector((state) => state.userState)
  const isAccess = module_access?.find((module) =>
    module.module_name === "Region & Locality" && module.is_editor === true
  ) ? true : false;

  const fetchRegions = async () => {
    try {
      const searchParams = { search: debounceSearchText };

      const params = statePopup || localGovernmentPopup ? {} : { page: regionCurrentPage, per_page: perPage };
      const resp = await getRegionList(searchParams, params);
      if (statePopup || localGovernmentPopup) {
        if (resp.data.success) {
          setRegionData(resp.data.payload);
        }
      }
      else if (resp.data.results.success) {
        setRegionData(resp.data.results.payload);
        setRegionCount(resp.data.count);
      }

    } catch (error) {
      console.log(error);
      notifyError(error.response.data.message);
    }
  };
  // 🔹 Fetch only states when updated
  const fetchStates = async () => {
    try {
      const searchParams = { search: debounceSearchText };

      const params = localGovernmentPopup ? {} : { page: stateCurrentPage, per_page: perPage };
      const resp = await getStateList(searchParams, params);
      if (localGovernmentPopup) {
        if (resp.data.success) {
          setStateData(resp.data.payload);
        }
      }
      else if (resp.data.results.success) {
        setStateData(resp.data.results.payload);
        setStateCount(resp.data.count);
      }
    } catch (error) {
      console.log(error);
      notifyError(error.response.data.message);
    }
  };
  // 🔹 Fetch only local governments when updated
  const fetchLocalGovernments = async () => {
    try {
      const searchParams = { search: debounceSearchText };
      const resp = await getLocalGovernmentList(searchParams, localGovCurrentPage, perPage);
      if (resp.data.results.success) {
        setLocalGovernmentData(resp.data.results.payload);
        setLocalGovCount(resp.data.count);
      }
    } catch (error) {
      console.log(error);
      notifyError(error.response.data.message);
    }
  };
  useEffect(() => {
    if (activeTab === 0) {
      fetchRegions();
    } else if (activeTab === 1) {
      fetchStates();
    } else if (activeTab === 2) {
      fetchLocalGovernments();
    }
  }, [activeTab, debounceSearchText, regionCurrentPage, stateCurrentPage, localGovCurrentPage])
  // 🔹 Fetch only updated data
  useEffect(() => {
    if (regionUpdated) {
      fetchRegions();
      setRegionUpdated(false); // Reset flag
    }
  }, [regionUpdated]);
  useEffect(() => {
    if (statePopup) {
      fetchRegions();
    } else if (localGovernmentPopup) {
      fetchRegions();
      fetchStates();
    }
  }, [statePopup, localGovernmentPopup]);
  useEffect(() => {
    if (stateUpdated || regionUpdated) {
      fetchStates();
      setStateUpdated(false); // Reset flag
      setRegionUpdated(false) // Reset flag
    }
  }, [stateUpdated, regionUpdated]);
  useEffect(() => {
    if (localGovUpdated || stateUpdated || regionUpdated) {
      fetchLocalGovernments();
      setLocalGovUpdated(false); // Reset flag
      setStateUpdated(false); // Reset flag
      setRegionUpdated(false) // Reset flag
    }
  }, [localGovUpdated, stateUpdated, regionUpdated]);

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      const fileType = file.name.split('.').pop().toLowerCase();
      if (fileType === 'xlsx' || fileType === 'xls') {
        setSelectedFile(file);
      } else {
        notifyError(translations[language].pleaseSelectExcelFile || 'Please select an Excel file');
        event.target.value = null; // Reset file input
      }
    }
  };
  const handleTabChange = (event, newValue) => {
    setActiveTab(newValue);
    setSelectedRegionsTable([]);
    setSelectedStateTable([]);
    setSelectedLocalgovTable([]);
  };
  const handleAddRegion = async (e) => {
    e.preventDefault();
    if (!isAccess) {
      notifyError(translations[language].youDontHaveAccess);
      return true;
    }
    if (!regionName) {
      notifyError(translations[language].pleaseEnterRegion);
      return;
    }
    const params = {
      region_name: regionName
    }
    try {
      setRegionLoading(true);
      const resp = await addRegionList(params);
      if (resp.data.success == true) {
        setRegionPopup(false);
        notifySuccess(resp.data.message);
        setRegionName("");  // Reset input field
        fetchRegions();
        setTimeout(() => {
          setRegionLoading(false);
        }, 2000);
      }
    } catch (error) {
      console.log(error);
      notifyError(error.response.data.message);
      setRegionPopup(false);
      setTimeout(() => {
        setRegionLoading(false);
      }, 2000);
      setRegionName("");
    }
  }
  const handleAddState = async (e) => {
    e.preventDefault();
    if (!isAccess) {
      notifyError(translations[language].youDontHaveAccess);
      return true;
    }
    if (!selectedRegion) {
      notifyError(translations[language].pleaseSelectRegion);
      return;
    }
    if (!state) {
      notifyError(translations[language].pleaseEnterStateName);
      return;
    }
    const params = {
      region: selectedRegion,
      state_name: state
    }
    try {
      setStateLoading(true);
      const resp = await addStateList(params);
      if (resp.data.success == true) {
        notifySuccess(resp.data.message);
        setStatePopup(false);
        setState(""); // Reset input field
        setSelectedRegion(""); // Reset selected region
        fetchStates();
        setTimeout(() => {
          setStateLoading(false);
        }, 2000);
      }

    } catch (error) {
      console.log(error);
      notifyError(error.response.data.message);
      setStatePopup(false);
      setTimeout(() => {
        setStateLoading(false);
      }, 2000);
      setState("");
      setSelectedRegion("");
    }
  }
  const handleAddLocalGovernment = async (e) => {
    e.preventDefault();
    if (!isAccess) {
      notifyError(translations[language].youDontHaveAccess);
      return true;
    }
    if (!selectedRegion) {
      notifyError(translations[language].pleaseSelectRegion);
      return;
    }

    if (!selectedState) {
      notifyError(translations[language].pleaseSelectState);
      return;
    }

    if (!category) {
      notifyError(translations[language].pleaseEnterLocalGovernmentName);
      return;
    }
    const params = {
      region: selectedRegion,
      state: selectedState,
      local_government_name: category,
    };

    try {
      setLocalGovLoading(true);
      const resp = await addLocalGovernmentList(params);
      if (resp.data.success === true) {
        setLocalGovernmentPopup(false);
        notifySuccess(resp.data.message);
        fetchLocalGovernments();
        setCategory(""); // Reset input field
        setSelectedState(""); // Reset selected state
        setSelectedRegion(""); // Reset selected region
        setTimeout(() => {
          setLocalGovLoading(false);
        }, 2000);
      }
    } catch (error) {
      console.log(error);
      notifyError(error.response.data.message);
      setLocalGovernmentPopup(false);
      setTimeout(() => {
        setLocalGovLoading(false);
      }, 2000);
      setCategory("");
      setSelectedState("");
      setSelectedRegion("");
    }
  };
  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedSearchText(searchText); // Update the debounced searchText
    }, 500); // 500ms debounce delay

    return () => {
      clearTimeout(handler); // Cleanup the timeout
    };
  }, [searchText]); // Effect runs when searchText changes

  const getStateBasedOnRegion = async (regionId) => {
    try {
      const resp = await getStateDetails(regionId);
      if (resp.data.results.success == true) {
        setStateBasedOnRegion(resp.data.results.payload)
      }
    } catch (error) {
      console.log("error", error);
      notifyError(error.response.data.message);
    }
  };

  useEffect(() => {
    if (selectedRegion) {
      getStateBasedOnRegion(selectedRegion)
    }

  }, [selectedRegion]);

  const handleCancel = (e) => {
    if (e) e.preventDefault(); // Prevents default behavior (useful for form buttons)
    setRegionPopup(false);
    setStatePopup(false);
    setLocalGovernmentPopup(false);
    setRegionName("");
    setSelectedRegion();
    setStateBasedOnRegion([]);
    setState("");
    setSelectedState();
    setCategory("");
  };

  const handleBulkDelete = async () => {
    if (!isAccess) {
      notifyError(translations[language].youDontHaveAccess);
      return true;
    }
    setBulkDeleteLoading(true);

    const params = {
      ids: activeTab === 0 ? selectedRegionsTable : activeTab === 1 ? selectedStateTable : selectedlocalgovTable
    }

    try {
      let resp;
      if (activeTab === 0) {
        resp = await regionBulkDelete(params);
      } else if (activeTab === 1) {
        resp = await stateBulkDelete(params);
      } else if (activeTab === 2) {
        resp = await localgovBulkDelete(params);
      }

      if (resp.data.success) {
        notifySuccess(resp.data.message);
        if (activeTab === 0) {
          fetchRegions();
          setSelectedRegionsTable([]);
        } else if (activeTab === 1) {
          fetchStates();
          setSelectedStateTable([]);
        } else if (activeTab === 2) {
          fetchLocalGovernments();
          setSelectedLocalgovTable([]);
        }
      }
      setTimeout(() => {
        setBulkDeleteLoading(false);
      }, 2000);


    } catch (error) {
      console.log(error);
      notifyError(error.response.data.message);
      setTimeout(() => {
        setBulkDeleteLoading(false);
      }, 2000);
    }
  }

  const handleDemoFile = async () => {
    if (!isAccess) {
      notifyError(translations[language].youDontHaveAccess);
      return true;
    }
    const params = {
      type: activeTab === 0 ? "region" : activeTab === 1 ? "state" : "local_government"
    }
    try {
      const res = await getRegionLocalityDemoFile(params);
      if (res.data.success == true) {
        downloadFile(res);
        notifySuccess(translations[language].downloadSuccess);
      }
    } catch (error) {
      console.log("error", error);
      notifyError(error.response?.data?.message || translations[language].downloadFailed);
    }
  }

  const handleImportExcel = async (e) => {
    if (!isAccess) {
      notifyError(translations[language].youDontHaveAccess);
      return true;
    }
    e.preventDefault();
    if (!selectedFile) {
      notifyError(translations[language].pleaseSelectFile);
      return;
    }
    const formData = new FormData();
    formData.append("file", selectedFile);
    const importApi = activeTab === 0 ? importRegionExcel : activeTab === 1 ? importStateExcel : activeTab === 2 && importLocalGovernmentExcel;
    try {
      setImportExcelLoading(true);
      const resp = await importApi(formData);
      if (resp.data.success === true) {
        notifySuccess(resp.data.message);
        fetchRegions();
        fetchStates();;
        fetchLocalGovernments();
        setImportExcel(false);
        setSelectedFile(null);
        setImportExcelLoading(false);
      }
    } catch (error) {
      console.log("error", error);
      notifyError(error.response.data.message);
      setImportExcel(false);
      setSelectedFile(null);
      setImportExcelLoading(false);
    }
  };

  const language = process.env.REACT_APP_LANGUAGE;
  return (
    <>
      <Box className="task-assign-box">
        <Box className="d-flex justify-content-between align-items-center" style={{ flexWrap: "wrap" }}>
          <Box className="d-flex  gap-3 img-box" style={{ padding: "25px" }}>
            <img src={region.region} alt="" />
            <Typography variant="h6" gutterBottom>
              {translations[language].regionAndLocality}
            </Typography>
          </Box>
          <Box className="assign-data-btn">
            <img
              src={region.deleteIcon}
              alt=""
              className="delete-btn"
              style={{ cursor: bulkDeleteLoading ? "not-allowed" : "pointer", marginRight: "10px" }}
              disabled={bulkDeleteLoading}
              onClick={() => handleBulkDelete()}
            />
            <button className="deactivate-btn" style={{ marginRight: "10px" }} onClick={() => handleDemoFile()}>
              {translations[language].demoFile}
            </button>
            <button
              className="deactivate-btn"
              style={{ marginRight: "10px" }}
              onClick={() => {
                if (!isAccess) {
                  notifyError(translations[language].youDontHaveAccess);
                  return true;
                }
                setImportExcel(true)
              }
              }
            >
              {translations[language].importExcel}
            </button>
            {activeTab === 0 && (
              <button
                className="assign-task-btn"
                style={{ marginLeft: "0px" }}
                onClick={() => {
                  if (!isAccess) {
                    notifyError(translations[language].youDontHaveAccess);
                    return true;
                  }
                  setRegionPopup(true)}
                }
              >
                {translations[language].addRegion}
              </button>
            )}
            {activeTab === 1 && (
              <button
                className="assign-task-btn"
                style={{ marginLeft: "0px" }}
                onClick={() => {
                  if (!isAccess) {
                    notifyError(translations[language].youDontHaveAccess);
                    return true;
                  }
                  setStatePopup(true)}
                }
              >
                {translations[language].addState}
              </button>
            )}
            {activeTab === 2 && (
              <button
                className="assign-task-btn"
                style={{ marginLeft: "0px" }}
                onClick={() => {
                  if (!isAccess) {
                    notifyError(translations[language].youDontHaveAccess);
                    return true;
                  }
                  setLocalGovernmentPopup(true)}
                }
              >
                {translations[language].addLocalGovernment}
              </button>
            )}
          </Box>
        </Box>
        <Box sx={{ width: "max-content" }} className="pt-2">
          <Tabs
            value={activeTab}
            onChange={handleTabChange}
            className="custom-tabs data-tabs"
            TabIndicatorProps={{ style: { display: "none" } }}
          >
            <Tab label={translations[language].region} />
            <Tab label={translations[language].state} />
            <Tab label={translations[language].localGovernment} />
          </Tabs>
        </Box>
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            border: "1px solid #31A05F",
            borderRadius: "8px",
            overflow: "hidden",
            margin: "0px 20px",
            boxShadow: "0px 4px 10px rgba(151, 151, 151, 0.12)",
          }}
          className="mt-3 mb-4"
        >
          <TextField
            placeholder="Search here"
            variant="outlined"
            size="small"
            sx={{
              flex: 1,
              "& .MuiOutlinedInput-root": {
                borderRadius: 0,
                paddingRight: "0px",
                "& fieldset": {
                  border: "none",
                },
              },
            }}
            value={searchText}
            onChange={(e) => setSearchText(e.target.value)}
            InputProps={{
              endAdornment: (
                <InputAdornment
                  position="end"
                  sx={{
                    color: "#FFFFFF",
                    fontWeight: "400",
                    backgroundColor: "#31A05F",
                    height: "100%",
                    padding: "0px",
                    maxHeight: "unset",
                    padding: "0px 15px",
                  }}
                >
                  <SearchIcon sx={{ color: "#FFFFFF", mr: 1 }} />
                  Search
                </InputAdornment>
              ),
            }}
          />
        </Box>
        <Box>
          <div className="tab-content">
            {activeTab === 0 &&
              <RegionTable
                regionData={regionData}
                setRegionUpdated={setRegionUpdated}
                regionCurrentPage={regionCurrentPage}
                setRegionCurrentPage={setRegionCurrentPage}
                regionCount={regionCount}
                perPage={perPage}
                selectedRegionsTable={selectedRegionsTable}
                setSelectedRegionsTable={setSelectedRegionsTable}
              />}
            {activeTab === 1 &&
              <StateTable
                stateData={stateData}
                regionData={regionData}
                setStateUpdated={setStateUpdated}
                stateCurrentPage={stateCurrentPage}
                setStateCurrentPage={setStateCurrentPage}
                stateCount={stateCount}
                perPage={perPage}
                selectedStateTable={selectedStateTable}
                setSelectedStateTable={setSelectedStateTable}
              />}
            {activeTab === 2 &&
              <LocalGovernment
                localGovernmentData={localGovernmentData}
                stateData={stateData}
                regionData={regionData}
                setLocalGovUpdated={setLocalGovUpdated}
                localGovCurrentPage={localGovCurrentPage}
                setLocalGovCurrentPage={setLocalGovCurrentPage}
                localGovCount={localGovCount}
                perPage={perPage}
                selectedlocalgovTable={selectedlocalgovTable}
                setSelectedLocalgovTable={setSelectedLocalgovTable}
              />}
          </div>
        </Box>
        <Dialog
          open={regionpopup}
          maxWidth="xs"
          fullWidth
          disableScrollLock
          PaperProps={{
            sx: { borderRadius: "12px" },
          }}
        >
          <div className="assign-div">
            {" "}
            <div className="d-flex justify-content-around align-items-center">
              <h5 className="p-3 mb-0" style={{ textAlign: "center" }}>
                {translations[language].addRegion}
              </h5>
            </div>
          </div>
          <DialogContent>
            <form noValidate autoComplete="off">
              <TextField
                fullWidth
                label={translations[language].enterRegion}
                name="regionTitle"
                value={regionName}
                onChange={(e) => {
                  const inputValue = e.target.value;
                  // Allow only letters and spaces, limit to 50 characters
                  if (/^[A-Za-z\s]*$/.test(inputValue) && inputValue.length <= 50) {
                    setRegionName(inputValue);
                  }
                }}
                inputProps={{ maxLength: 50 }}
                className="mb-3"
              />

              <div className="d-flex gap-3 mt-2">
                <button
                  className="cancel-button"
                  onClick={handleCancel}
                >
                  {translations[language].cancel}
                </button>
                <button
                  className="assign-task-button"
                  disabled={regionLoading}
                  onClick={(e) => handleAddRegion(e)}
                >
                  {regionLoading ? <span className="spinner"></span> : translations[language].addRegion}
                </button>
              </div>
            </form>
          </DialogContent>
        </Dialog>
        <Dialog
          open={statePopup}
          maxWidth="xs"
          fullWidth
          disableScrollLock
          PaperProps={{
            sx: { borderRadius: "12px" },
          }}
        >
          <div className="assign-div">
            {" "}
            <div className="d-flex justify-content-around align-items-center">
              <h5 className="p-3 mb-0" style={{ textAlign: "center" }}>
                {translations[language].addState}
              </h5>
            </div>
          </div>
          <DialogContent>
            <form noValidate autoComplete="off">
              <FormControl fullWidth className="mb-3">
                <InputLabel>{translations[language].selectRegion}</InputLabel>
                <Select
                  label={translations[language].selectRegion}
                  name="region"
                  value={selectedRegion}
                  onChange={(e) => setSelectedRegion(e.target.value)}
                >
                  {regionData.map((item, index) => (
                    <MenuItem value={item.id}>{item.region_name}</MenuItem>
                  ))}
                </Select>
              </FormControl>
              <TextField
                fullWidth
                label={translations[language].enterState}
                name="taskTitle"
                value={state}
                onChange={(e) => {
                  const inputValue = e.target.value;
                  // Allow only letters and spaces, limit to 50 characters
                  if (/^[A-Za-z\s]*$/.test(inputValue) && inputValue.length <= 50) {
                    setState(inputValue);
                  }
                }}
                inputProps={{ maxLength: 50 }}
                className="mb-3"
              />

              <div className="d-flex gap-3 mt-2">
                <button
                  className="cancel-button"
                  onClick={handleCancel}
                >
                  {translations[language].cancel}
                </button>
                <button
                  className="assign-task-button"
                  disabled={stateLoading}
                  onClick={(e) => handleAddState(e)}
                >
                  {stateLoading ? <span className="spinner"></span> : translations[language].addState}
                </button>
              </div>
            </form>
          </DialogContent>
        </Dialog>
        <Dialog
          open={localGovernmentPopup}
          maxWidth="xs"
          fullWidth
          disableScrollLock
          PaperProps={{
            sx: { borderRadius: "12px" },
          }}
        >
          <div className="assign-div">
            {" "}
            <div className="d-flex justify-content-around align-items-center">
              <h5 className="p-3 mb-0" style={{ textAlign: "center" }}>
                {translations[language].addLocalGovernment}
              </h5>
            </div>
          </div>
          <DialogContent>
            <form noValidate autoComplete="off">
              <FormControl fullWidth className="mb-3">
                <InputLabel>{translations[language].selectRegion}</InputLabel>
                <Select
                  label={translations[language].selectRegion}
                  name="region"
                  value={selectedRegion}
                  onChange={(e) => setSelectedRegion(e.target.value)}
                >
                  {regionData.map((item, index) => (
                    <MenuItem key={index} value={item.id}>{item.region_name}</MenuItem>
                  ))}
                </Select>
              </FormControl>
              <FormControl fullWidth className="mb-3">
                <InputLabel>{translations[language].selectState}</InputLabel>
                <Select
                  label={translations[language].selectState}
                  name="state"
                  value={selectedState}
                  onChange={(e) => setSelectedState(e.target.value)}
                >
                  {selectedRegion && stateBasedOnRegion.length === 0 ? (
                    <MenuItem disabled>{translations[language].noOptionAvailable}</MenuItem>
                  ) : (
                    !selectedRegion && (
                      <MenuItem disabled>{translations[language].pleaseSelectRegion}</MenuItem>
                    )
                  )}
                  {stateBasedOnRegion.map((item, index) => (
                    <MenuItem key={index} value={item.id}>{item.state_name}</MenuItem>
                  ))}
                </Select>
              </FormControl>
              <TextField
                fullWidth
                label={translations[language].enterLocalGovernment}
                name="taskTitle"
                value={category}
                onChange={(e) => {
                  const inputValue = e.target.value;
                  // Allow only letters and spaces, limit to 50 characters
                  if (/^[A-Za-z\s]*$/.test(inputValue) && inputValue.length <= 50) {
                    setCategory(inputValue);
                  }
                }}
                inputProps={{ maxLength: 50 }}
                className="mb-3"
              />

              <div className="d-flex gap-3 mt-2">
                <button
                  className="cancel-button"
                  onClick={handleCancel}
                  style={{ fontSize: "14px" }}
                >
                  {translations[language].cancel}
                </button>
                <button
                  className="assign-task-button"
                  onClick={(e) => handleAddLocalGovernment(e)}
                  style={{ fontSize: "14px" }}
                  disabled={localGovLoading}
                >
                  {localGovLoading ? <span className="spinner"></span> : translations[language].addLocalGovernment}
                </button>
              </div>
            </form>
          </DialogContent>
        </Dialog>
        <Dialog
          open={importExcel}
          maxWidth="xs"
          fullWidth
          disableScrollLock
          PaperProps={{
            sx: { borderRadius: "12px" },
          }}
        >
          <div className="assign-div">
            {" "}
            <div className="d-flex justify-content-around align-items-center">
              <h5 className="p-3 mb-0" style={{ textAlign: "center" }}>
                {translations[language].importExcel}
              </h5>
            </div>
          </div>
          <DialogContent>
            <Box textAlign="center">
              <input
                type="file"
                accept=".xlsx, .xls"
                id="file-upload"
                style={{ display: "none" }}
                onChange={handleFileChange}
              />
              <label htmlFor="file-upload">
                <Box
                  sx={{
                    width: "390px",
                    height: "150px",
                    border: "2px dashed #3C4856",
                    borderRadius: "8px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    cursor: "pointer",
                    overflow: "hidden",
                    backgroundColor: "#fff",
                    boxShadow: "0px 4px 10px rgba(160, 160, 160, 0.16)"
                  }}
                >
                  {selectedFile ? (
                    <Box textAlign="center">
                      <img
                        src={region.browseImage} // You can replace this with an Excel icon
                        alt="Excel"
                        style={{ width: 50, height: 50, marginBottom: 8 }}
                      />
                      <Box sx={{ fontSize: "14px", fontWeight: 500 }}>
                        {selectedFile.name}
                      </Box>
                      <Box sx={{ fontSize: "12px", color: "#555" }}>
                        {(selectedFile.size / 1024).toFixed(1)} KB
                      </Box>
                    </Box>
                  ) : (
                    <img src={region.browseImage} alt="" />
                  )}
                </Box>
              </label>
              <div className="d-flex gap-3 mt-4">
                <button
                  className="cancel-button"
                  onClick={(e) => {
                    e.preventDefault();
                    setImportExcel(false);
                  }}
                >
                  {translations[language].cancel}
                </button>
                <button
                  className="assign-task-button"
                  onClick={(e) => handleImportExcel(e)}
                  style={{ cursor: importExcelLoading ? "not-allowed" : "pointer" }}
                  loading={importExcelLoading}
                  disabled={importExcelLoading}
                >
                  {translations[language].submit}
                </button>
              </div>
            </Box>
          </DialogContent>
        </Dialog>
      </Box>
    </>
  );
};
export default Region;